// [key, title, description]
// Code framework: IBC Chapter 6
// Note: Sub-types (IA/IB, IIA/IIB, etc.) are deferred to a future phase when a US customer is onboarded.

export const CONSTRUCTION_TYPES_US = [
  [
    'type_i',
    'Type I – Fire-Resistive',
    'Concrete or protected steel. Highest fire-resistance requirements. No height or area limit for most occupancies.',
  ],
  [
    'type_ii',
    'Type II – Non-Combustible',
    'Steel or concrete with lower fire-resistance requirements than Type I. Common for commercial mid-rise.',
  ],
  [
    'type_iii',
    'Type III – Ordinary',
    'Noncombustible exterior walls with combustible interior framing. Common for mixed-use low-rise.',
  ],
  [
    'type_iv',
    'Type IV – Heavy Timber / Mass Timber',
    'Large dimension wood members. 2021 IBC introduced Type IV-A, IV-B, IV-C sub-types for mass timber — top-level only in current phase.',
  ],
  [
    'type_v',
    'Type V – Wood Frame',
    'Light-framed combustible construction. Most common for low-rise residential.',
  ],
];